import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import React from 'react';
import { useStepperContext } from '../../context/StepperContext';
import { stepperStyles } from '../../../shared/styles';
import { useLoginContext } from '../../../../../contexts/LoginContext';

const ProfileDropdown: React.FC = ({}) => {
  const { handleProfileChange, isNewProfile } = useStepperContext();

  const { user, selectedProfileIndex } = useLoginContext();

  return (
    <FormControl size="small" sx={{ minWidth: 200, width: '100%' }}>
      <InputLabel id="profile-select-label" sx={{ fontSize: '0.875rem' }}>
        Notification Profile
      </InputLabel>
      <Select
        labelId="profile-select-label"
        id="profile-select"
        value={selectedProfileIndex}
        label="Notification Profile"
        onChange={handleProfileChange}
        disabled={isNewProfile}
        sx={{
          ...stepperStyles.textField,
          width: '100%',
          '& .MuiInputBase-input': {
            fontSize: '0.875rem',
            borderRadius: 2,
          },
          '& .MuiInputLabel-root': {
            fontSize: '0.875rem',
            borderRadius: 2,
          },
        }}
        autoFocus={true}
      >
        {user.extProfiles.map((profile, index) => (
          <MenuItem key={index} value={index} sx={{ fontSize: '0.875rem' }}>
            {profile.name || 'Please Enter Name'}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default ProfileDropdown;
